import { endPoints, requestType } from "../lib/Variable";
import Api from "./index";

const getALlWebUsers = (params) => {
  return Api(endPoints.getAllWebUsers, params, requestType.GET);
};

const customerBankValidation = (params) => {
  return Api(endPoints.customerBankValidation, params, requestType.POST);
};

const customerPhoneValidation = (phone) => {
  return Api(
    `${endPoints.customerPhoneValidation}?phone=${phone}`,
    null,
    requestType.GET
  );
};

export { getALlWebUsers, customerBankValidation, customerPhoneValidation };
